import { ContextStore } from '@src/contexts/AppContextStore/context-store'
import { InitContextStore } from '@src/lib/CustomSSR/withCustomSSR'

const _contextStore: ContextStore<any> = null

export function initContextStore(
  getContextStore: InitContextStore,
  options?: { contextState?: any }
): ContextStore {
  return getContextStore({ contextState: options?.contextState })
}
